export enum Spacing {
  S2 = '2px',
  S4 = '4px',
  S6 = '6px',
  S8 = '8px',
  S10 = '10px',
  S12 = '12px',
  S14 = '14px',
  S16 = '16px',
  S20 = '20px',
  S24 = '24px',
  S32 = '32px',
  S40 = '40px',
  S80 = '80px',
}
